import {ScheduleRange} from "@services/types";
import moment from "moment-timezone";

export const formatMinOpen = (
  timezone: string,
  selectedLocationHours?: ScheduleRange[],
  currentCalendarTime?: number,
): number | null | undefined => {
  const dateTimeNow = moment().tz(timezone).format("YYYY-MM-DD HH:mm");
  const currentDate = moment(currentCalendarTime).tz(timezone).format("YYYY-MM-DD"); // Selected Date

  const isCurrentDateBeforeDateNow = moment(currentDate).isBefore(moment(dateTimeNow), "day");
  if (isCurrentDateBeforeDateNow) return null;

  const currentDayWorkingHours = selectedLocationHours?.find(
    d => d.day === moment(currentDate).day(),
  );

  if (!currentDayWorkingHours?.to || !currentDayWorkingHours?.from) return null;

  const currentDayStartH = moment(currentDate + " " + currentDayWorkingHours?.from);
  const currentDayEndH = moment(currentDate + " " + currentDayWorkingHours?.to);

  const isCurrentDayClinicDay = moment(dateTimeNow).isSame(moment(currentDate), "day");
  const isAfterWorkingH = moment(dateTimeNow).isAfter(currentDayEndH);

  if (isCurrentDayClinicDay && isAfterWorkingH) return null;

  const openMinutes = Math.round(
    moment
      .duration(moment(currentDayEndH).diff(isCurrentDayClinicDay ? dateTimeNow : currentDayStartH))
      .asMinutes(),
  );

  if (openMinutes) return openMinutes;
};
